import { InjectionToken } from '@angular/core';

export const MODE_INJECTION_TOKEN = new InjectionToken<boolean>('Mode Injection Token');